import React from 'react'

const VehicleTypeOption = ({id, onClick, title, icon, isActive}) => {
    return (
        <div
            onClick={() => onClick(id)}
            className={`front-vehicle-option ${isActive ? 'front-vehicle-option-active' : ''}`}>
            {/*<img src={icon} alt=""/>*/}
            <div
                className="front-vehicle-option-icon"
                style={{backgroundImage: `url(${icon})`}}></div>
            <p>{title}</p>
        </div>
    )
}

export default VehicleTypeOption